import { Button } from "../UIElements/Button";
import React from "react";
import { Icon } from "../UIElements/Icon";

const CampaignsError = ({ error, onRetry }) => {
  const errorMessage =
    error?.message || "An error occurred while loading campaigns.";

  return (
    <div className="ordering-campaigns-error py-12 text-center" role="alert">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--error-bg)]">
        <Icon name="AlertTriangle" className="text-destructive h-8 w-8" />
      </div>
      <h3 className="text-foreground mb-2 text-lg font-medium">
        Failed to load campaigns
      </h3>
      <p className="text-muted-foreground mx-auto mb-6 max-w-md">
        {errorMessage}
      </p>
      {onRetry && (
        <Button
          variant="default"
          type="button"
          onClick={onRetry}
          className="inline-flex items-center space-x-2 px-4 py-2"
        >
          <Icon name="RefreshCw" className="h-4 w-4" />
          <span>Try Again</span>
        </Button>
      )}
    </div>
  );
};

export default CampaignsError;
